
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1axkx_7cwlx_9",
  "item": "awsui_item_1axkx_7cwlx_47",
  "disable-item-paddings": "awsui_disable-item-paddings_1axkx_7cwlx_50",
  "disable-paddings": "awsui_disable-paddings_1axkx_7cwlx_53",
  "sortable-item": "awsui_sortable-item_1axkx_7cwlx_60"
};
  